import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';
import { useTranslation } from "react-i18next";

// import PROP from '../../constant/PROP';
import usePadLogin from "../../hooks/usePadLogin";
import { usePmChecker, useUserInfo, useNetwork } from "../../hooks";
import { getDataFormApp } from '../../utils/utilityEtc';
import { setDeviceInfoAction } from "../../redux/deviceInfo";
import { TYPE, URL } from "../../constant";
import { appBackBtnEventFunc, appBbackgroundEvent, appForegroundEvent } from "../../utils/appEventFunc";
import { setVerbObject } from "../../redux/logData";
import useCommonCode from "../../hooks/useCommonCode";

const EntryExternalAppDataAndAutoLogin = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const lastLocation = useLastLocation();
  const { i18n } = useTranslation()
  const { pathname } = useLocation();
  const { setInfo, info } = useUserInfo();
  const { networkCheck } = useNetwork();
  const { getGeoIPAPICall } = useCommonCode();


  const [pmCheckStop, pmCheckStart] = usePmChecker();

  // const deviceInfo = useSelector(state => state.deviceInfo);
  
  useEffect(() => {
    let locale = localStorage.getItem('locale')
    if (locale) i18n.changeLanguage(locale.toLowerCase());
  }, [info]);

  const {
    // globalLogin,
    smartAllLogin,
    gmLogin,
    cpLogin,
    gmAPPLogin,
    gbAPPLogin,
    initialState,
  } = usePadLogin();

  // app에서 최초 진입 시 받는 데이터
  const parsing = () => {

    if (pathname === URL.LEAVE.GOOGLE_LEVEL || pathname === URL.LEAVE.SUCCESS) return;
    const data = getDataFormApp();

    if (data.entryType) {
      localStorage.setItem("channel.code", data.chnCd);
      dispatch( setDeviceInfoAction( { channelCode : data.chnCd } ) );
      entryFunction(data);
    }
  
    // 로컬 제외하고 pm 체크
    if (process.env.REACT_APP_ENV !== 'local') {
      if (data?.pmCheck === 'N') {
        pmCheckStop();
      } else {
        pmCheckStart();
      }
    }
  };

  // 진입 후 분기처리 함수
  const entryFunction = async (value) => {
    // 앱 데이터 set 저장
    setInfo({
      channelCode: value.chnCd,
      contractNum: value.contract,
      learnerCode: value.cMember,
      userCode: value.pMember,
      entryType: value.entryType,
      pmCheck: value.pmCheck,
      cntrtNo: value.cntrtNo
    });
    // handlePmChecked(value.pmCheck)

    await getGeoIPAPICall();

    switch (value.entryType) {
      // 교문 패드 로그인
      case TYPE.ENTRY_TYPE.GM:
        gmLogin(value)
        break;
      // 스마트올 패드 로그인
      case TYPE.ENTRY_TYPE.WJTB:
        smartAllLogin(value)
        break;
      // 글로벌 로그인 (임시)
      case TYPE.ENTRY_TYPE.GLOBAL01:
        gbAPPLogin(value);
        break;
      // 교문 탈패드 APP
      case TYPE.ENTRY_TYPE.GM_APP:
        gmAPPLogin(value);
        break;
      // CP모델
      case TYPE.ENTRY_TYPE.CP:
        cpLogin(value)
        break;
      // 매쓰피드 APP
      case TYPE.ENTRY_TYPE.MATH_PID:
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("OCR", async (e) => {
      if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
console.log(e?.detail);
      }
      history.push({
        pathname: URL.OCR.I,
        state: {
          detail: e?.detail
        }
      })
    });
    parsing();
    networkCheck()
    
    appBackBtnEventFunc({ history, lastLocation });
    appForegroundEvent();
    appBbackgroundEvent();
  }, [] );

  // useEffect(() => {
  //   console.log({ main: lastLocation });
  //   if (!lastLocation) return;
  //   const { state = undefined, search = "" } = lastLocation;
  //   dispatch(setAppBackbtnEventData({ params: { state, search  }}));
  // }, [lastLocation])
  
  return initialState && props.children
};


export default EntryExternalAppDataAndAutoLogin;
